import { render, staticRenderFns } from "./HighContrastSwitch.vue?vue&type=template&id=6597a508"
import script from "./HighContrastSwitch.vue?vue&type=script&lang=js"
export * from "./HighContrastSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports